(function () {
  'use strict';
  var source = document.currentScript.dataset.emblaSrc;
  var selectors = '[data-embla],slider-component .slider,slideshow-component .slider,.cs-ugc__track,.cs-rstrip__track,.cs-nums__track,.cs-door__list,.cs-gthumbs,.cs-bund__track,.cs-revs__track,.cs-cart__upst,[data-cea-track],[data-ced-track],.ce-abx-rs__track';
  var pending, scheduled;
  function scan() {
    scheduled = false;
    if (window.ceEmbla) { window.ceEmbla.scan(document); return; }
    var needed = [].some.call(document.querySelectorAll(selectors), function (track) {
      if (track.hasAttribute('data-embla')) return track.firstElementChild && track.firstElementChild.children.length > 1;
      return track.children.length > 1 && track.clientWidth > 0 && track.scrollWidth > track.clientWidth + 2;
    });
    if (!needed || pending) return;
    pending = document.querySelector('script[src*="/ce-embla.js"]');
    if (!pending) {
      pending = document.createElement('script');
      pending.src = source;
      pending.defer = true;
      pending.addEventListener('error', function () { pending.remove(); pending = null; });
      document.head.appendChild(pending);
    }
    pending.addEventListener('load', function () { if (window.ceEmbla) window.ceEmbla.scan(document); });
  }
  function schedule() { if (!scheduled) { scheduled = true; requestAnimationFrame(scan); } }
  function start() {
    scan();
    new MutationObserver(function (entries) {
      if (entries.some(function (entry) { return [].some.call(entry.addedNodes, function (node) { return node.nodeType === 1 && (node.matches(selectors) || node.querySelector(selectors)); }); })) schedule();
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.addEventListener('resize', schedule);
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('ce:carousel-content', scan);
})();
